// 学历
export const identityType = [
    { value: 'SELF', text: '自费' },
    { value: 'FREE', text: '公费' },
];
